<template>
  <div class="radio-group-sub filter_flex">
    <div>
      <label v-if="title !== ''" class="title">
        <span class="btn btn-sm ripple-effect btn-default filter_but btn-link" style="padding: 0.375rem 0;pointer-events: none;">
          {{title}}
        </span>
      </label>
    </div>
    <div>
      <label v-if="all" class="m-r-10">
        <input :checked="value === ''" @click="change({id: '', item: all})" type="radio" :name="name">
        <span class="btn btn-sm ripple-effect btn-default filter_but btn-link">
          {{all}}
        </span>
      </label><label class="m-r-10" v-for="(item, index) in data" :key="index">
        <input :checked="value === item.label" @click="change(item)" type="radio" :name="name">
        <span class="btn btn-sm ripple-effect btn-default filter_but btn-link">
          {{item.label}}
        </span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'radio-group-sub',
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: ''
    },
    all: {
      type: [String, Boolean],
      default: '全部'
    },
    name: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      default: []
    }
  },
  data() {
    return {}
  },
  methods: {
    change(data) {
      this.$emit('change', data)
    }
  }
}
</script>

<style lang='scss' scoped>
  .filter_flex {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
  }
  .radio-group-sub {
    .title {
      min-width: 80px;
      text-align: right;
    }
    label{
      margin: 0;
    }
  }
  .filter_but {
    padding: 0.375rem 0.75rem;
    transition: 0.2s ease-in;
  }
  [type='radio']:checked + .filter_but {
    color: #fff;
    background: #1976d2;
    border: 1px solid #1976d2;
    box-shadow: 0 2px 2px 0 rgba(66, 165, 245, 0.14),
      0 3px 1px -2px rgba(66, 165, 245, 0.2), 0 1px 5px 0 rgba(66, 165, 245, 0.12);
  }
  .btn-link,
  .btn-link:focus,
  .btn-link:hover {
    text-decoration: none;
    color: #777;
  }
</style>



// WEBPACK FOOTER //
// src/components-base/components-custom/filter-group/filter-group.vue